<script>
  export let text;
</script>

<style>
  div.preloader {
    display: flex;
    flex-direction: column;
  }

  span {
    color: var(--revista-blue);
  }
</style>

<div class="preloader">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
  <span>{text}</span>
</div>
